import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeStep, nextStep } from '../../redux/actions/StepperAction';
import { BpCheckbox, InputError } from '../../utils';
import { useState } from 'react';
import { acceptRule } from '../../../api/MoadianService';
import { useNavigate } from "react-router-dom";

export default function Rules({ setOpenModal }) {
    const dispatch = useDispatch();
    const [accept, setAccept] = useState(false);
    const [error, setError] = useState("");
    const tokenInfo = useSelector(state => state.Token)
    const navigate = useNavigate();

    const rules = [
        "استفاده از درگاه اینترنتی گواهیت (www.govahit.ir) به منزله قبول و تعهد به رعایت قوانین زیر است و در صورت عدم رعایت قوانین، این درگاه حق محدودیت یا قطع دسترسی کاربر را دارد.",
        "این گواهی برای ثبت نام و بارگذاری فاکتور در سامانه مودیان سازمان امور مالیاتی قابل استفاده است.",
        "گواهی دیجیتال صادره فقط برای اهداف مالیاتی و در چارچوب قوانین مالیاتی کشور استفاده می‌شود. هرگونه استفاده غیرمجاز از گواهی دیجیتال ممنوع است و پیگرد قانونی خواهد داشت.",
        "این گواهی برای شخص کاربر یا سازمانی که کاربر به عنوان نماینده آن معرفی شده است، صادر شده است. کاربر به هیچ عنوان حق انتقال آن بصورت جزئی یا کلی به دیگران را ندارد.",
        "کاربر متعهد به نگهداری امن اطلاعات حساب کاربری و عدم افشای آن است.",
        "کاربر مسئولیت کامل حفظ و نگهداری کلید خصوصی خود را بر عهده دارد.",
        "درگاه اینترنتی هیچ مسئولیتی در قبال از دست رفتن یا سوءاستفاده از کلید خصوصی کاربر ندارد.",
        "کاربر موظف به پرداخت هزینه‌های مربوط به صدور گواهی دیجیتال و خدمات مرتبط با آن است.",
        "پرداخت‌ها باید صرفاً از طریق درگاه پرداخت موجود در درگاه اینترنتی گواهیت انجام شوند و هرگونه پرداخت خارج از این چارچوب بی اعتبار خواهد بود.",
        "درگاه اینترنتی گواهیت متعهد به حفظ امنیت و حریم خصوصی اطلاعات کاربران است.",
        "انصراف از ادامه روند اخذ گواهی و عودت وجه قبل از صدور گواهی امکان پذیر است و پس از آن امکان انصراف و عودت وجه وجود ندارد. تا قبل از مرحله صدور گواهی در هر مرحله از فرایند که کاربر انصراف دهد، هزینه احتمالی مراحل باقیمانده قابل بازپرداخت خواهد بود و هزینه مراحل گذشته غیرقابل بازگشت است.",
        "درگاه اینترنتی گواهیت حق تغییر و بروزرسانی قوانین کاربری خود را در هر زمان برای خود محفوظ می‌داند. و کاربران موظف به مطالعه و رعایت آخرین نسخه قوانین منتشر شده در درگاه اینترنتی هستند.",
        "در صورت نیاز به اطلاعات بیشتر با شماره 02191014648 داخلی 404 و 401 یا شماره همراه 09329640013 تماس حاصل فرمایید.",
    ]
    const [isSubmitted, setIsSubmitted] = useState(false)

    function AccpetRule() {
        setIsSubmitted(true)
        if (accept) {
            acceptRule(tokenInfo.transactionId)
                .then(response => {
                    setIsSubmitted(false)
                    setError('')
                    // dispatch(nextStep())
                    navigate('/main')

                })
                .catch(error => {
                    console.error(error.response.data.message)
                    setIsSubmitted(false)
                    setError(error.response.data.message)
                })


        } else {
            setIsSubmitted(false)
            setError("لطفا قوانین را تایید کنید")
        }
    }

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
            width: "80%",
        },
    })

    return (
        <Box sx={style} className="rule-width p-2">
            <div>
                <p className="header-text mt-1" style={{ "color": "black", "lineHeight": "normal" }}>قوانین</p>
                <p className="text-format">لطفا قوانین را با دقت مطالعه و تایید بفرمایید</p>
            </div>

            <div className='rounded p-3 m-md-3 mt-2 rule-modal ltr'>

                <div className='rtl'>

                    {
                        rules.map((row, index) => (
                            <div className='text-format-rule my-2'>
                                <span style={{ "color": "#0BA9B5", fontWeight: "500" }}>{index + 1} - </span>
                                <span>{row}</span>
                            </div>
                        ))
                    }


                </div>


            </div>

            <div className='mx-3'>
                <BpCheckbox name="accept-rule" id="accept-rule" onClick={(e) => setAccept(e.target.checked)} />
                <label className="text-format" style={{ "color": "#4D4D4D" }}>با توجه به مطالب فوق، اینجانب مایل به اخذ گواهی هستم.</label>
                <div className='m-0 me-3 mb-2'>
                    {error && <InputError message={error} />}
                </div>

            </div>

            <div className='d-flex justify-content-evenly'>


                {accept ?
                    <button
                        className='btn text-form-button'
                        style={{ "background": "#044448", "padding": "1.5% 13%" }}
                        onClick={AccpetRule}
                        disabled={isSubmitted}
                    >تایید</button>

                    :
                    <button
                        disabled
                        className='btn text-form-button mx-1'
                        style={{ "background": "#7f7d7ddb", "padding": "1.5% 13%" }}
                    >تایید </button>
                }


            </div>
            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </Box>

    )
}